import React, { Component, PropTypes } from 'react';
import Modal from '../../commons/Modal/Modal';

class GalleryDeleteConfirmationModal extends Component {
    static propTypes = {
        onConfirm: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired
    };

    handlePositiveClick = () => {
        this.props.onConfirm();
    };

    handleNegativeClick = () => {
        this.props.onCancel();
    };

    render() {
        return (
            <Modal id="confirmDeleteGalleryItem"
                   onPositiveClickEvent={this.handlePositiveClick}
                   onNegativeClickEvent={this.handleNegativeClick}
                   positiveButton="Confirm"
                   negativeButton="Cancel"
                   header="Delete Confirmation" isSaving={this.props.isSaving}>

                Are you sure you would like to delete this gallery record?
            </Modal>
        )
    }
}

export default GalleryDeleteConfirmationModal;


/** WEBPACK FOOTER **
 ** ./src/components/GalleryDeleteConfirmModal/index.js
 **/